
import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { tipoMenuEnum } from '../../enum/index';

export const SideBarData = [
  {
    title: 'Salir',
    path: '/logout',
    icon: <AiIcons.AiOutlineExport />,
    tipo: tipoMenuEnum.Item,
    id: 0
  },
  {
    title: 'Principal',
    path: '/',
    icon: <AiIcons.AiFillHome />,
    tipo: tipoMenuEnum.Item,
    id: 0
  },
  {
    title: 'Reportes',
    path: '/reportes',
    icon: <FaIcons.FaFileDownload />,
    tipo: tipoMenuEnum.Item,
    id: 1
  },
  {
    title: 'Emisor',
    path: '/emisor',
    icon: <AiIcons.AiOutlineSolution />,
    tipo: tipoMenuEnum.Item,
    id: 2
  },
  {
    title: 'Inventario',
    path: '/productos',
    icon: <FaIcons.FaBuffer />,
    tipo: tipoMenuEnum.Item,
    id: 3
  },
  {
    title: 'Facturas',
    icon: <FaIcons.FaMoneyCheckAlt />,
    iconClosed: <FaIcons.FaAngleDown />,
    iconOpened: <FaIcons.FaAngleUp />,
    tipo: tipoMenuEnum.SubMenu,
    estado: false,
    id: 4,
    subNav: [
      {
        title: 'Listar Facturas',
        path: '/facturas',
        icon: <FaIcons.FaList />
      },
      {
        title: 'Crear Factura',
        path: '/crearfactura',
        icon: <FaIcons.FaMoneyCheckAlt />
      },
      {
        title: 'Listar Factura Compras',
        path: '/facturasCompras',
        icon: <FaIcons.FaMoneyCheckAlt />
      },
      {
        title: 'Crear Factura Compra',
        path: '/crearFaturaCompra',
        icon: <FaIcons.FaMoneyCheckAlt />
      }
    ]
  },
  {
    title: 'Notas',
    icon: <FaIcons.FaMoneyCheck />,
    iconClosed: <FaIcons.FaAngleDown />,
    iconOpened: <FaIcons.FaAngleUp />,
    tipo: tipoMenuEnum.SubMenu,
    estado: false,
    id: 5,
    subNav: [
      {
        title: 'Listar Nota de Crédito',
        path: '/notascredito',
        icon: <FaIcons.FaList />,
      },
      {
        title: 'Crear Notas de Crédito',
        path: '/crearnotacredito',
        icon: <FaIcons.FaMoneyCheck />,
      },
      {
        title: 'Listar Notas de Débito',
        path: '/notasdebito',
        icon: <FaIcons.FaList />,
      },
      {
        title: 'Crear Nota de Débito',
        path: '/crearnotadebito',
        icon: <FaIcons.FaMoneyCheck />,
      }
    ]
  },
  {
    title: 'Tiquetes',
    icon: <FaIcons.FaTicketAlt />,
    iconClosed: <FaIcons.FaAngleDown />,
    iconOpened: <FaIcons.FaAngleUp />,
    tipo: tipoMenuEnum.SubMenu,
    estado: false,
    id: 6,
    subNav: [
      {
        title: 'Listar Tiquetes',
        path: '/tiquetes',
        icon: <FaIcons.FaList />,
      },
      {
        title: 'Crear Tiquete',
        path: '/creartiquete',
        icon: <FaIcons.FaTicketAlt />,
      }
    ]
  },
  {
    title: 'Confirmación Facturas',
    icon: <FaIcons.FaCheck />,
    iconClosed: <FaIcons.FaAngleDown />,
    iconOpened: <FaIcons.FaAngleUp />,
    tipo: tipoMenuEnum.SubMenu,
    id: 7,
    estado: false,
    subNav: [
      {
        title: 'Listar Confirmadas',
        path: '/listarconfirmadas',
        icon: <FaIcons.FaList />,
      },
      {
        title: 'Confirmar Facturas',
        path: '/confirmacionfacturas',
        icon: <FaIcons.FaTicketAlt />,
      }
    ]
  }
];